<h2 class="mt-0" mat-dialog-title>Changer de contenu</h2>

<div class="container flexParent">
  <div class="container flexChild">
    <mat-form-field class="full-width" appearance="outline">
      <input matInput [(ngModel)]="query" (keyup)="performSearch()" placeholder="Search course" />
    </mat-form-field>
    <mat-list role="list">
      @for (course of result; track course) {
        <mat-list-item role="listitem" class="userListItem" (click)="selectCourse(course)">
          {{ course.actualName }}
        </mat-list-item>
      }
    </mat-list>
  </div>
  <div class="container flexChild">
    @if (selectedCourse) {
      <mat-accordion class="flex-column flex-center">
        @for (section of selectedCourse.sections; track section; let i = $index) {
          <mat-expansion-panel class="course-list-section">
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <div class="section-title">
                  <span class="section-number mat-color-primary-400">{{ i + 1 }}.</span>
                  <span class="section-name mat-color-primary-400">{{ section?.name }}</span>
                </div>
                <div style="flex: 5"></div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="section-button-list"></div>
            <mat-list>
              @for (lecture of section.lectures; track lecture) {
                <mat-list-item style="margin: 0; padding: 0" class="cursor">
                  <div style="display: flex; width: 100%; padding: 0">
                    <div style="flex: 5; width: 95%; padding-top: 7px" (click)="selectContent(section, lecture)">
                      <mat-label>{{ lecture?.name }}</mat-label>
                    </div>
                    <div style="flex: 1; width: 5%; float: right; padding: 0">
                      <div style="display: flex">
                        <div class="mat-icon-btn"></div>
                      </div>
                    </div>
                  </div>
                </mat-list-item>
              }
            </mat-list>
          </mat-expansion-panel>
        }
        <br />
      </mat-accordion>
    }
  </div>
</div>
